module.exports = __webpack_public_path__ + "img/home-panel-companies.2770bfd8.svg";